import PropTypes from 'prop-types';
import React from 'react';

import {CNPJ_TYPES, PARTNERS_TYPES} from '../../../constants/typesMessages';
import Form from '../../Form';
import FlowCnpj from '../FlowCnpj';

const FlowsSelect = (props) => {
  switch (props.valueType) {
    case CNPJ_TYPES.CNPJ_FLOW:
      return <FlowCnpj {...props} />;

    case PARTNERS_TYPES.PARTNERS_FLOW:
      return <div id="partners-flow" />;

    default:
      return <Form {...props} />;
  }
};

FlowsSelect.propTypes = {
  valueType: PropTypes.string
};

export default FlowsSelect;
